import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import EllipsisText_styles from "./EllipsisText.styles.js";
const EllipsisText = (t0)=>{
    const $ = c(8);
    const { rows: t1, wordBreak: t2, children, hyphens: t3, maxWidth } = t0;
    const rows = void 0 === t1 ? 2 : t1;
    const wordBreak = void 0 === t2 ? "normal" : t2;
    const hyphens = void 0 === t3 ? false : t3;
    let t4;
    if ($[0] !== hyphens || $[1] !== maxWidth || $[2] !== rows || $[3] !== wordBreak) {
        t4 = {
            rows,
            wordBreak,
            hyphens,
            maxWidth
        };
        $[0] = hyphens;
        $[1] = maxWidth;
        $[2] = rows;
        $[3] = wordBreak;
        $[4] = t4;
    } else t4 = $[4];
    const { classes } = EllipsisText_styles(t4);
    const t5 = `${classes.ellipsis} aqa_ellipsis_text`;
    let t6;
    if ($[5] !== children || $[6] !== t5) {
        t6 = /*#__PURE__*/ jsx("span", {
            className: t5,
            "data-testid": "ellipsis-text-test-id",
            children: children
        });
        $[5] = children;
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    return t6;
};
export { EllipsisText };
